import { render, staticRenderFns } from "./RecordDetailPopup.vue?vue&type=template&id=ab97297e&scoped=true"
import script from "./RecordDetailPopup.vue?vue&type=script&lang=js"
export * from "./RecordDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./RecordDetailPopup.vue?vue&type=style&index=0&id=ab97297e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab97297e",
  null
  
)

export default component.exports